import React from "react";
import { Page } from "@shopify/polaris";
import styled from "styled-components";

import { ProductsIgnoredPolaris } from "../../components/product/ignored/ProductsIgnoredPolaris";

const Container = styled.div`
  margin: -1rem;
  @media (min-width: 640px) {
    margin: -1.5rem;
  }
`;

export const ProductsIgnoredPagePolaris = () => {
  return (
    <Container>
      <Page title="Products Ignored" fullWidth>
        <ProductsIgnoredPolaris />
      </Page>
    </Container>
  );
};
